__turbopack_context__.v({
  "checkbox-item": "CheckboxInput-module-scss-module__IvPKIG__checkbox-item",
  "control": "CheckboxInput-module-scss-module__IvPKIG__control",
  "field-legend": "CheckboxInput-module-scss-module__IvPKIG__field-legend",
  "group": "CheckboxInput-module-scss-module__IvPKIG__group",
  "indicator": "CheckboxInput-module-scss-module__IvPKIG__indicator",
  "select-all": "CheckboxInput-module-scss-module__IvPKIG__select-all",
});
